import { mailApiHeaders } from './mailApiHeaders';

export type SendBetaEventCodeRejectEmailParams = {
  to: string;
  fullName: string;
  message: string;
  organization?: string;
};

export type SendBetaEventCodeRejectEmailResult =
  | { ok: true; messageId?: string }
  | { ok: false; skipped?: boolean; error: string };

type ApiOk = { ok: true; messageId?: string };
type ApiErr = { ok: false; skipped?: boolean; code?: string; message?: string; error?: string };

function apiUrl(): string {
  const base = (process.env.REACT_APP_API_BASE as string | undefined)?.replace(/\/$/, '') ?? '';
  return base
    ? `${base}/api/send-beta-event-code-reject-email`
    : '/api/send-beta-event-code-reject-email';
}

function mapApiResult(
  res: Response,
  data: ApiOk | ApiErr | null,
): SendBetaEventCodeRejectEmailResult {
  if (!data || typeof data !== 'object') {
    return {
      ok: false,
      skipped: false,
      error: res.ok ? 'EMPTY_RESPONSE' : `HTTP_${res.status}`,
    };
  }
  if ('ok' in data && data.ok === true) {
    return { ok: true, messageId: (data as ApiOk).messageId };
  }
  const err = data as ApiErr;
  return {
    ok: false,
    skipped: Boolean(err.skipped),
    error: err.error ?? err.message ?? err.code ?? 'SEND_FAILED',
  };
}

/** 요청자에게 베타 코드 요청 반려 안내 메일 발송 */
export async function sendBetaEventCodeRejectEmail(
  params: SendBetaEventCodeRejectEmailParams,
): Promise<SendBetaEventCodeRejectEmailResult> {
  try {
    const res = await fetch(apiUrl(), {
      method: 'POST',
      headers: await mailApiHeaders(),
      body: JSON.stringify(params),
    });
    let data: ApiOk | ApiErr | null = null;
    try {
      data = (await res.json()) as ApiOk | ApiErr;
    } catch {
      data = null;
    }
    return mapApiResult(res, data);
  } catch (e) {
    return {
      ok: false,
      skipped: false,
      error: e instanceof Error ? e.message : String(e),
    };
  }
}
